/* Nuage & Cie : panier, pack de 5 kits, grille, fiche produit */
(() => {
  const NC = window.NC || {};
  NC.compare = NC.compare || 14.95;
  const N = 5, PAGE = 24;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const $ = s => document.querySelector(s);
  const $$ = s => [...document.querySelectorAll(s)];
  const eur = v => v.toFixed(2).replace(".", ",") + " €";
  const IMG = {};
  (NC.products || []).forEach(p => { IMG[p.t] = p.img; });
  const ICO = {
    gift: '<svg class="i" viewBox="0 0 24 24"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3 9h18M12 9v11M12 9c-1.5-3.5-5.5-4-5.5-1.5S10 9 12 9zm0 0c1.5-3.5 5.5-4 5.5-1.5S14 9 12 9z"/></svg>',
    plus: '<svg class="i" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg class="i" viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    arrow: '<svg class="i" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    lock: '<svg class="i" viewBox="0 0 24 24"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
  };

  /* ---------- compte à rebours : jusqu'à NC.timerEnd, puis cycles de 48 h ---------- */
  const cd = $("#annCd");
  const CYCLE = 48 * 3600e3;
  let end = Date.parse(NC.timerEnd || "") || Date.now() + CYCLE;
  const tick = () => {
    if (!cd) return;
    const now = Date.now();
    if (end <= now) end += Math.ceil((now - end + 1) / CYCLE) * CYCLE;
    const s = Math.floor((end - now) / 1000), d = Math.floor(s / 86400);
    const hms = [(s % 86400) / 3600, (s % 3600) / 60, s % 60].map(x => String(Math.floor(x)).padStart(2, "0")).join(":");
    cd.textContent = d ? `${d} j ${hms}` : hms;
  };
  tick(); setInterval(tick, 1000);

  /* ---------- panier ---------- */
  let cart = { items: [], total_price: 0, item_count: 0 };
  const api = (url, body) => fetch(ROOT + url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } }).then(r => r.json());
  const isPack = it => NC.packVariant && it.variant_id === NC.packVariant;
  const singles = () => cart.items.filter(it => !isPack(it));
  const nSingles = () => singles().reduce((a, it) => a + it.quantity, 0);
  const nPacks = () => cart.items.filter(isPack).reduce((a, it) => a + it.quantity, 0);
  const packTitles = it => Object.entries(it.properties || {}).filter(([k]) => /^Kit/.test(k)).map(([, v]) => v);
  const remember = () => cart.items.forEach(it => { if (!isPack(it) && it.image) IMG[it.product_title] = it.image; });

  async function load() { cart = await api("cart.js"); remember(); }
  // 5 kits à l'unité dans le panier = on les remplace par le produit pack à 19,99 €
  async function normalize() {
    if (!NC.packVariant) return;
    while (nSingles() >= N) {
      const units = [];
      singles().forEach(it => { for (let q = 0; q < it.quantity; q++) units.push(it); });
      const take = units.slice(0, N), dec = {};
      take.forEach(it => dec[it.key] = (dec[it.key] || 0) + 1);
      const updates = {};
      Object.entries(dec).forEach(([key, d]) => { const it = cart.items.find(x => x.key === key); updates[key] = it.quantity - d; });
      await api("cart/update.js", { updates });
      const properties = {}; take.forEach((it, i) => properties[`Kit ${i + 1}`] = it.product_title + (it.variant_title && !/24 ongles/.test(it.variant_title) ? ` (${it.variant_title})` : ""));
      await api("cart/add.js", { items: [{ id: NC.packVariant, quantity: 1, properties }] });
      await load();
    }
  }
  async function addVariants(ids, open, btn) {
    if (btn) btn.classList.add("busy");
    await api("cart/add.js", { items: ids.map(id => ({ id: +id, quantity: 1 })) });
    await load(); await normalize();
    render();
    if (btn) { btn.classList.remove("busy"); btn.classList.add("ok"); }
    if (open) openCart();
  }
  async function addPack(titles, open) {
    const properties = {}; titles.forEach((t, i) => properties[`Kit ${i + 1}`] = t.t);
    if (!NC.packVariant) { await addVariants(titles.map(t => t.v), open); return; }
    await api("cart/add.js", { items: [{ id: NC.packVariant, quantity: 1, properties }] });
    await load(); render(); if (open) openCart();
  }
  async function changeLine(key, qty) { await api("cart/change.js", { id: key, quantity: qty }); await load(); await normalize(); render(); }

  const openCart = () => { $("#drawer").classList.add("show"); $("#ovl").classList.add("show"); };
  const closeCart = () => { $("#drawer").classList.remove("show"); $("#ovl").classList.remove("show"); };
  $("#openCart")?.addEventListener("click", openCart);
  $("#ovl")?.addEventListener("click", closeCart);
  addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  function packMsg() {
    const s = nSingles(), p = nPacks();
    if (s === 0 && p === 0) return `Choisis <b>5 kits</b> et paye <b>${eur(NC.packPrice)}</b> au lieu de ${eur(N * NC.compare)}`;
    if (s === 0) return `Pack complet : <b>5 kits pour ${eur(NC.packPrice)}</b>`;
    if (s === N - 1) return `Plus qu'un kit : il ne te coûte que <b>${eur(NC.packPrice - (N - 1) * NC.unit)}</b>`;
    return `Encore <b>${N - s} kits</b> pour débloquer ${eur(NC.packPrice)}`;
  }
  const pct = () => { const s = nSingles(); return s ? s / N * 100 : (nPacks() ? 100 : 0); };

  function renderDrawer() {
    const d = $("#drawer"); if (!d) return;
    const count = nSingles() + nPacks() * N, tot = cart.total_price / 100;
    const saved = nPacks() * (N * NC.compare - NC.packPrice);
    const free = tot >= NC.shipFree - 0.001, ship = free ? 0 : NC.shipCost;
    const inCart = new Set(cart.items.map(it => it.variant_id));
    const ups = (NC.products || []).filter(p => !inCart.has(p.v)).slice(0, 10);
    d.innerHTML = `
      <div class="dh"><h3>Ton panier (${count})</h3><button type="button" data-close aria-label="Fermer">×</button></div>
      <div class="dprog"><p>${packMsg()}</p><div class="prog"><i style="width:${pct()}%"></i></div>
        <div class="marks"><span>1</span><span>2</span><span>3</span><span>4</span><span>5 = ${eur(NC.packPrice)}</span></div></div>
      <div class="items">${cart.items.length === 0 ? `<div class="empty"><p>Ton panier est léger comme un nuage.</p><br><a class="btn" href="${NC.colUrl || ROOT + "collections/all"}">Voir les kits</a></div>` :
        cart.items.map(it => isPack(it) ? `<div class="it"><span class="th"><img src="${it.image || ""}" alt=""></span>
            <div><b>Pack de 5 kits</b><small>${packTitles(it).join(", ")}</small>
            <div class="qty"><button type="button" data-chg="${it.key}" data-q="${it.quantity - 1}" aria-label="Retirer">−</button><span>${it.quantity}</span></div></div>
            <div class="pr">${eur(it.final_line_price / 100)}<br><s style="font-weight:600;color:var(--muted);font-size:12px">${eur(N * NC.compare * it.quantity)}</s></div></div>` :
          `<div class="it"><a class="th" href="${it.url}"><img src="${it.image || ""}" alt=""></a>
            <div><b>${it.product_title}</b><small>${it.variant_title && !/24 ongles/.test(it.variant_title) ? it.variant_title : "Kit 24 ongles · 12 tailles"}</small>
            <div class="qty"><button type="button" data-chg="${it.key}" data-q="${it.quantity - 1}" aria-label="Retirer">−</button><span>${it.quantity}</span><button type="button" data-chg="${it.key}" data-q="${it.quantity + 1}" aria-label="Ajouter">+</button></div></div>
            <div class="pr">${eur(it.final_line_price / 100)}</div></div>`).join("")}</div>
      ${nSingles() > 0 ? `<div class="upsell"><p>Complète ton pack</p><div class="up-row">${ups.map(p => `<button type="button" title="${p.t}" data-add="${p.v}"><img src="${p.img}" alt="${p.t}" loading="lazy"></button>`).join("")}</div></div>` : ""}
      ${cart.items.length ? `<div class="df">
        ${saved > 0.001 ? `<div class="ln save"><span>Tu économises (${nPacks()} pack${nPacks() > 1 ? "s" : ""} de 5)</span><span>−${eur(saved)}</span></div>` : ""}
        <div class="ln"><span>Livraison</span><span>${free ? "<b style='color:var(--green)'>Offerte</b>" : eur(ship)}</span></div>
        <div class="ln pressn-adjust" data-pressn-adjust-row hidden><span data-pressn-adjust-label></span><strong data-pressn-adjust-value></strong></div>
        <div class="tot" data-pressn-total-row><span>Total à payer</span><span data-pressn-final-value>${eur(tot + ship)}</span></div>
        <a class="btn btn-block" data-pressn-checkout href="${ROOT}checkout">Commander · <span data-pressn-final-value>${eur(tot + ship)}</span></a>
        <p data-pressn-status hidden role="alert"></p>
        <div class="sec2">${ICO.lock} Paiement sécurisé · CB, PayPal, Apple Pay</div></div>` : ""}`;
  }

  function slots(titles, removable, removeAttr = "data-rmt") {
    return `<div class="slots">${Array.from({ length: N }, (_, i) => { const t = titles[i]; return t ?
      `<div class="slot on"><img src="${IMG[t] || ""}" alt="${t}">${removable ? `<button type="button" class="x" ${removeAttr}="${i}" aria-label="Retirer">×</button>` : ""}</div>` :
      `<div class="slot ${i === N - 1 ? "gift" : ""}">${i === N - 1 ? ICO.gift : i + 1}</div>`; }).join("")}</div>
      <div class="slot-lbl"><span>Kit 1</span><span>Kit 2</span><span>Kit 3</span><span>Kit 4</span><span>Kit 5</span></div>`;
  }
  function renderPackBox() {
    const b = $("#packBox"); if (!b) return;
    let titles = [];
    singles().forEach(it => { for (let q = 0; q < it.quantity; q++) titles.push(it.product_title); });
    if (!titles.length && nPacks()) titles = packTitles(cart.items.filter(isPack).slice(-1)[0]).map(t => t.replace(/ \(.*\)$/, ""));
    const done = nSingles() === 0 && nPacks() > 0;
    b.innerHTML = slots(titles, !done) + `
      <div class="prog"><i style="width:${pct()}%"></i></div>
      <p class="pack-msg">${packMsg()}</p>
      <div class="pack-foot"><div class="pack-price">${eur(NC.packPrice)}<s>${eur(N * NC.compare)}</s><small>soit ${eur(NC.packPrice / N)} le kit · livraison offerte</small></div>
      ${done ? `<button type="button" class="btn" data-open>Voir mon panier ${ICO.arrow}</button>` :
        `<a class="btn" href="#collection" data-go="collection">${nSingles() ? "Continuer mon pack" : "Choisir mes 5 kits"} ${ICO.arrow}</a>`}</div>`;
  }
  function renderCards() {
    const q = {};
    cart.items.forEach(it => { if (!isPack(it)) q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
    $$(".card .add[data-add]").forEach(b => {
      const n = q[+b.dataset.add] || 0;
      b.classList.toggle("ok", n > 0);
      b.innerHTML = n ? `${ICO.check}<span>Ajouté${n > 1 ? " ×" + n : ""} · encore +1</span>` : `${ICO.plus}<span>Ajouter au pack</span>`;
    });
    const c = $("#cartCount"); if (c) c.textContent = nSingles() + nPacks() * N;
  }
  function render() { renderDrawer(); renderPackBox(); renderCards(); renderSticky(); window.PRESSNPriceRouter?.refresh?.(cart); }

  /* ---------- clics ---------- */
  document.addEventListener("click", e => {
    const t = e.target.closest("[data-add],[data-chg],[data-close],[data-open],[data-rmt],[data-go]");
    if (!t) return;
    if (t.dataset.add) { e.preventDefault(); addVariants([t.dataset.add], false, t.classList.contains("add") ? t : null); }
    else if (t.dataset.chg) changeLine(t.dataset.chg, Math.max(0, +t.dataset.q));
    else if (t.hasAttribute("data-close")) closeCart();
    else if (t.hasAttribute("data-open")) openCart();
    else if (t.dataset.rmt !== undefined) {
      let i = +t.dataset.rmt;
      for (const it of singles()) { if (i < it.quantity) { changeLine(it.key, it.quantity - 1); break; } i -= it.quantity; }
    }
    else if (t.dataset.go) {
      const el = document.getElementById(t.dataset.go);
      if (el) { e.preventDefault(); scrollTo({ top: el.getBoundingClientRect().top + scrollY - 100, behavior: "smooth" }); }
    }
  });

  /* ---------- onglets + affichage par paquets de 24 ---------- */
  let tab = "best", shown = PAGE;
  const inTab = (tags, t) => t === "all" || new RegExp("(^|\\s)" + t + "(\\s|$)").test(tags);
  function applyTab() {
    let k = 0;
    const cards = $$("#grid .card");
    cards.forEach(c => {
      const ok = inTab(c.dataset.tags || "", tab);
      c.style.display = ok ? "" : "none";
      if (ok) { k++; c.classList.toggle("off-page", k > shown); }
    });
    const more = $("#more"); if (more) more.style.display = k > shown ? "" : "none";
  }
  $$("#tabs button").forEach(b => b.addEventListener("click", () => {
    tab = b.dataset.t; shown = PAGE;
    $$("#tabs button").forEach(x => x.classList.toggle("on", x === b)); applyTab();
  }));
  $("#more")?.addEventListener("click", () => { shown += PAGE; applyTab(); });
  if ($("#grid") && $("#tabs")) applyTab();

  /* ---------- fiche produit ---------- */
  const pdp = $("#pdp");
  let mode = "pack", picks = [], atcVisible = true;
  if (pdp) {
    const me = { t: pdp.dataset.title, v: +pdp.dataset.variant, img: pdp.dataset.img };
    IMG[me.t] = me.img;
    const isPackPage = pdp.dataset.pack === "true";
    const need = isPackPage ? N : N - 1;
    const others = (NC.products || []).filter(p => p.t !== me.t);
    const mini = $("#mini");
    mini.innerHTML = others.map(o => `<button type="button" title="${o.t}" data-pk="${o.t}"><img loading="lazy" src="${o.img}" alt="${o.t}"></button>`).join("");
    const atc = $("#atc"), picker = $("#picker");

    // variantes (forme / teinte)
    const vjson = $("#variants");
    if (vjson) {
      const variants = JSON.parse(vjson.textContent), sel = $$(".vo").map(vo => vo.querySelector(".vb.on")?.dataset.val);
      $$(".vb").forEach(b => b.addEventListener("click", () => {
        const o = +b.dataset.opt; sel[o] = b.dataset.val;
        $$(`.vb[data-opt="${o}"]`).forEach(x => x.classList.toggle("on", x === b));
        const lbl = $(`[data-optlbl="${o}"]`); if (lbl) lbl.textContent = b.dataset.val;
        const v = variants.find(x => x.o.every((val, i) => val === sel[i]));
        if (v) me.v = v.id;
      }));
    }

    const gal = $("#mainImg"), imgs = $$("#mainImg img.gi");
    const show = i => {
      if (getComputedStyle(gal).display === "flex") gal.scrollTo({ left: gal.clientWidth * i, behavior: "smooth" });
      imgs.forEach((x, k) => x.classList.toggle("cur", k === i));
      $$(".thumbs button").forEach((b, k) => b.classList.toggle("on", k === i));
    };
    show(0);
    $$(".thumbs button").forEach(b => b.addEventListener("click", () => show(+b.dataset.pick)));
    gal.addEventListener("scroll", () => { const i = Math.round(gal.scrollLeft / gal.clientWidth); $$("#dots i").forEach((d, k) => d.classList.toggle("on", k === i)); }, { passive: true });

    const byT = Object.fromEntries((NC.products || []).map(p => [p.t, p]));
    const renderPicker = () => {
      const all = isPackPage ? picks : [me.t, ...picks];
      $("#pSlots").innerHTML = slots(all, true, "data-pr").replace(isPackPage ? /$^/ : /<button type="button" class="x" data-pr="0"[^>]*>×<\/button>/, "");
      const left = need - picks.length;
      $("#pickTxt").textContent = left ? `Choisis encore ${left} kit${left > 1 ? "s" : ""}` : "Ton pack est prêt !";
      $$("[data-pk]").forEach(b => { b.querySelector(".q")?.remove(); const q = picks.filter(s => s === b.dataset.pk).length; if (q) b.insertAdjacentHTML("beforeend", `<span class="q">${q}</span>`); });
      renderAtc();
    };
    const renderAtc = () => {
      if (mode === "one") atc.textContent = `Ajouter au panier · ${eur(NC.unit)}`;
      else atc.textContent = picks.length < need ? `Choisis encore ${need - picks.length} kit${need - picks.length > 1 ? "s" : ""}` : `Ajouter mon pack de 5 · ${eur(NC.packPrice)}`;
      renderSticky();
    };
    mini.addEventListener("click", e => { const b = e.target.closest("[data-pk]"); if (!b || picks.length >= need) return; picks.push(b.dataset.pk); renderPicker(); });
    $("#pSlots").addEventListener("click", e => { const b = e.target.closest("[data-pr]"); if (!b) return; picks.splice(+b.dataset.pr - (isPackPage ? 0 : 1), 1); renderPicker(); });
    $("#surprise").addEventListener("click", () => { while (picks.length < need && others.length) picks.push(others[Math.floor(Math.random() * others.length)].t); renderPicker(); });
    $$(".offer").forEach(o => o.addEventListener("click", () => { mode = o.dataset.mode; $$(".offer").forEach(x => x.classList.toggle("on", x === o)); picker.classList.toggle("hidden", mode !== "pack"); renderAtc(); }));
    window.ncAtc = async () => {
      if (mode === "one") { await addVariants([me.v], true); return; }
      if (picks.length < need) { picker.classList.remove("shake"); void picker.offsetWidth; picker.classList.add("shake"); picker.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
      const list = (isPackPage ? [] : [{ t: me.t, v: me.v }]).concat(picks.map(t => byT[t]));
      await addPack(list, true); picks = []; renderPicker();
    };
    atc.addEventListener("click", window.ncAtc);
    window.ncPdp = { me, label: () => mode === "one" ? `Ajouter · ${eur(NC.unit)}` : picks.length < need ? "Composer mon pack" : `Ajouter · ${eur(NC.packPrice)}`, sub: () => mode === "one" ? eur(NC.unit) : "Pack de 5 · " + eur(NC.packPrice) };
    new IntersectionObserver(([e]) => { atcVisible = e.isIntersecting || e.boundingClientRect.top > 0; renderSticky(); }).observe(atc);
    renderPicker();
  }

  /* ---------- barre fixe ---------- */
  function renderSticky() {
    const st = $("#sticky"); if (!st) return;
    if (window.ncPdp) {
      st.innerHTML = `<div class="th"><img src="${ncPdp.me.img}" alt=""></div><div class="info"><b>${ncPdp.me.t}</b><small>${ncPdp.sub()}</small></div>
        <button type="button" class="btn" id="stAtc">${ncPdp.label()}</button>`;
      $("#stAtc").onclick = window.ncAtc;
      st.classList.toggle("show", !atcVisible);
    } else {
      const s = nSingles(), p = nPacks();
      st.innerHTML = s || p ? `<div class="info"><b>Mon pack : ${s || 5}/5</b><small>${s ? `Encore ${N - s} kit${N - s > 1 ? "s" : ""} pour ${eur(NC.packPrice)}` : "5 kits pour " + eur(NC.packPrice)}</small></div>
        <button type="button" class="btn" data-open>Panier · ${eur(cart.total_price / 100)}</button>` :
        `<div class="info"><b>5 kits = ${eur(NC.packPrice)}</b><small>au lieu de ${eur(N * NC.compare)} · livraison offerte</small></div><a class="btn" href="${$("#pack") ? "#pack" : ROOT + "#pack"}" ${$("#pack") ? 'data-go="pack"' : ""}>Je compose</a>`;
      const hero = $(".hero");
      st.classList.toggle("show", hero ? hero.getBoundingClientRect().bottom < 0 : scrollY > 700);
    }
  }
  addEventListener("scroll", () => { if (!window.ncPdp) renderSticky(); }, { passive: true });

  /* ---------- bandeau cookies Shopify : textes en français ---------- */
  const frCookies = () => {
    const bn = document.getElementById("shopify-pc__banner");
    if (!bn || bn.dataset.fr) return !!bn;
    bn.dataset.fr = 1;
    const title = bn.querySelector("#shopify-pc__banner__body-title");
    const para = bn.querySelector(".shopify-pc__banner__body p");
    const link = bn.querySelector("#shopify-pc__banner__body-policy-link");
    if (title) title.textContent = "Un petit cookie ?";
    if (para && link) { link.textContent = "politique de confidentialité"; para.replaceChildren("On utilise des cookies pour que la boutique fonctionne bien, mesurer l'audience et te montrer des offres qui te plaisent. Tu choisis : ", link, "."); }
    const set = (id, t) => { const b = document.getElementById(id); if (b) (b.querySelector("span") || b).textContent = t; };
    set("shopify-pc__banner__btn-accept", "J'accepte");
    set("shopify-pc__banner__btn-decline", "Je refuse");
    set("shopify-pc__banner__btn-manage-prefs", "Gérer mes préférences");
    return true;
  };
  if (!frCookies()) {
    const mo = new MutationObserver(() => { if (frCookies()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 20000);
  }

  load().then(normalize).then(render).catch(() => render());
})();
